import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import DataTable from '../DataTable';

import { memberStateToString, roleNameToHungarian } from '../../../Utils/Converters';
import { MEMBER, ADMIN, NOT_A_MEMBER, POGANY, BALEK, FIRMA, ALL } from '../../../Data/Constants';

class UsersAdminPage extends Component {
    columns = [
        {
            header: 'Név',
            id: 'name',
            
            cell: row => <NavLink to={`/admin/users/${row.id}`}>{row.name}</NavLink>
        },
        {
            header: 'Email cím',
            accessor: 'email'
        },
        {
            header: 'Körtagság',
            accessor: 'memberState',
            cell: row => memberStateToString(row),
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : { ALL }}
                >
                    <option value={ALL}>Mind mutatása</option>
                    <option value={NOT_A_MEMBER}>{memberStateToString(NOT_A_MEMBER)}</option>
                    <option value={POGANY}>{memberStateToString(POGANY)}</option>
                    <option value={BALEK}>{memberStateToString(BALEK)}</option>
                    <option value={FIRMA}>{memberStateToString(FIRMA)}</option>
                </select>
            )
        },
        {
            header: 'Jogosultságok',
            id: 'role',
            
            sortable: false,
            cell: row => {
                const roleSpans = row.roles && row.roles.map((item, index) => {
                    return <span key={row.id + "_role_" + index}>{roleNameToHungarian(item)} </span>;
                });

                return (
                    <span>
                        {roleSpans}
                    </span>
                );
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : { ALL }}
                >
                    <option value={ALL}>Mind mutatása</option>
                    <option value={MEMBER}>{roleNameToHungarian(MEMBER)}</option>
                    <option value={ADMIN}>{roleNameToHungarian(ADMIN)}</option>
                </select>
            )
        },
        {
            header: 'Első bejelentkezés ideje',
            accessor: 'firstLoginDate',
            filterable: false,
            cell: row => new Date(row).toLocaleString("hu")
        },
        {
            header: 'Utolsó bejelentkezés ideje',
            accessor: 'lastLoginDate',
            filterable: false,
            cell: row => new Date(row).toLocaleString("hu")
        }
    ];

    render() {
        return (
            <>
                <h1>Felhasználók</h1>
                <DataTable url='/admin/users' columns={this.columns} />
            </>
        );
    }
}

export default UsersAdminPage;
